import React from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import MenuPage from '../../pages/MenuPage';

const CountryList = ({ countries }) => {

    return (
        <MenuPage title="Countries" onBackClick={()=>{alert("Klick")}}>

            <Table selectable={false} >
                <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                    <TableRow>
                        <TableHeaderColumn>Country Code</TableHeaderColumn>
                        <TableHeaderColumn>Country Name</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false} showRowHover={true}>
                    {countries.map((country,idx) =>
                        <TableRow key={idx}>
                            <TableRowColumn>{country.countryCode}</TableRowColumn>
                            <TableRowColumn>{country.name}</TableRowColumn>
                        </TableRow>
                        )
                    }
                </TableBody>
            </Table>
        </MenuPage>
    )
}

export default CountryList;



// WEBPACK FOOTER //
// ./src/components/countryList/CountryList.js